export default {
  authServiceUrl: 'http://localhost:8001',
  authApiUrl: 'http://localhost:8001/api',
  accApiUrl: 'http://localhost:8002',
  clientId: 'dha_management_webapp',
  tokenHandleUrl: `${window.location.origin}/auth/token`,
};



// WEBPACK FOOTER //
// ./src/configs/base.js